import { render, staticRenderFns } from "./PhotoTicker.vue?vue&type=template&id=18fca66f&scoped=true&"
import script from "./PhotoTicker.vue?vue&type=script&lang=js&"
export * from "./PhotoTicker.vue?vue&type=script&lang=js&"
import style0 from "./PhotoTicker.vue?vue&type=style&index=0&id=18fca66f&prod&lang=scss&scoped=true&"
import style1 from "./PhotoTicker.vue?vue&type=style&index=1&id=18fca66f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fca66f",
  null
  
)

export default component.exports